import React, { Suspense, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import "swiper/swiper-bundle.css";

import { BreadcrumbsHome } from "../components";
import { useTranslation } from "react-i18next";
import { API_BASE_URL } from "../constant";

import entreprise from "../assets/bank-assets/steps.png"; // TODO: STEPS IMG
import sectionBEA from "../assets/bank-assets/header.png";
import efacility from "../assets/logo-faciliti-FR- (2).svg";
import support_yellow from "../assets/icons/support.png";
import support_bleu from "../assets/icons/support_blue.png";
import file_yellow from "../assets/icons/file.png";
import file_blue from "../assets/icons/file_blue.png";
import criteria_yellow from "../assets/icons/criteria.png";
import criteria_blue from "../assets/icons/criteria_blue.png";
import condorLogo from "../assets/brands/condor.svg";

import cristorLogo from "../assets/brands/cristor.svg";
import nardiLogo from "../assets/brands/nardi.svg";
import hisenseLogo from "../assets/brands/hisense.svg";
import Cart from "../assets/icons/cart";

import { useDeviceSize } from "react-device-sizes";

import ProductCard from "../components/ProductCard";

import ReactGA from "react-ga4";

function Home() {
  ReactGA.send({
    hitType: "pageview",
    page: "/home",
    title: "BEA | Home",
  });

  const {
    xsDown, //(max-width: 575.98px)
    smDown, //(max-width: 767.98px)
    mdDown, //(max-width: 991.98px)
  } = useDeviceSize();

  const { t, i18n } = useTranslation();

  const [sliderList, setSliderList] = useState([]);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [buttonHovered, setButtonHovered] = useState(false);
  const [buttonHovered2, setButtonHovered2] = useState(false);
  const [buttonHovered3, setButtonHovered3] = useState(false);
  const bankName = ["BEA"];

  // const chunkArray = (array, chunkSize) => {
  //   const chunks = [];
  //   for (let i = 0; i < array.length; i += chunkSize) {
  //     chunks.push(array.slice(i, i + chunkSize));
  //   }
  //   return chunks;
  // };

  // Divide products into groups of eight
  // const productChunks = chunkArray(products, 8);

  const FilteredSliderSection = ({ sliderList }) => {
    // ? Filter sliderList based on allowed bank names
    // console.log("silderList: ", sliderList);
    const filteredSliders = sliderList.filter((slider) =>
      slider.bank.includes(bankName)
    );

    return (
      <div className="place-self-center">
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          loop={true}
          autoplay={{
            delay: 4500,
            disableOnInteraction: true,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[Autoplay, Pagination]}
          className="h-100"
        >
          {filteredSliders.map((slider, index) => (
            <SwiperSlide className="h-full w-full" key={index}>
              <Suspense
                fallback={
                  <div className="h-full w-full flex justify-center text-2xl">
                    Loading...
                  </div>
                }
              >
                <img
                  className="h-full w-full object-cover rounded-xl"
                  alt={slider.name}
                  src={`${API_BASE_URL + slider.url}`}
                />
              </Suspense>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  };

  const fetchProducts = async () => {
    setIsLoading(true);
    fetch(`${API_BASE_URL}api/products/getAll`, {
      method: "Get",
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        return res.json().then((apidata) => {
          setIsLoading(false);
          let errorMessage = "Authentication failed!";
          if (apidata && apidata.error && apidata.error.message) {
            errorMessage = apidata.error.message;
          }
          throw new Error(errorMessage);
        });
      })
      .then((apiData) => {
        if (Array.isArray(apiData)) {
          setProducts(
            apiData.filter((_product) => _product.populaire === true)
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setProducts([]);
        setIsLoading(false);
      });
  };

  const fetchSliderList = async () => {
    setIsLoading(true);
    await fetch(`${API_BASE_URL}api/sliders/getAll`, {
      method: "Get",
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
        return res.json().then((apidata) => {
          setIsLoading(false);
          let errorMessage = "Authentication failed!";
          if (apidata && apidata.error && apidata.error.message) {
            errorMessage = apidata.error.message;
          }
          throw new Error(errorMessage);
        });
      })
      .then((apiData) => {
        if (Array.isArray(apiData)) {
          setSliderList(apiData);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setSliderList([]);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchSliderList();
    fetchProducts();
  }, []);

  return (
    <div className="home-page pt-10 " style={{ textAlign: "-webkit-center" }}>
      <FilteredSliderSection sliderList={sliderList} />

      <div className="my-12">
        <div className="mx-auto px-2 md:px-6">
          <div
            className="grid grid-cols-2 gap-6 rounded-lg p-6 lg:grid-cols-4 gap-y-8"
            style={{ alignItems: "baseline" }}
          >
            <div className="flex justify-center  place-items-center">
              <Link
                to={{ pathname: "/products", state: { brands: ["Condor"] } }}
              >
                <img className="home-logos zoom" src={condorLogo} alt="..." />
              </Link>
            </div>
            <div className="flex flex-col align-baseline">
              <Link
                to={{ pathname: "/products", state: { brands: ["Cristor"] } }}
                className=""
              >
                <img
                  className="home-logos zoom mt-auto"
                  src={cristorLogo}
                  alt="..."
                />
              </Link>
            </div>
            <div className="flex justify-center place-items-center">
              <Link
                to={{ pathname: "/products", state: { brands: ["Nardi"] } }}
              >
                <img className="home-logos zoom" src={nardiLogo} alt="..." />
              </Link>
            </div>
            <div className="flex justify-center place-items-center">
              <Link
                to={{ pathname: "/products", state: { brands: ["Hisense"] } }}
              >
                <img className="home-logos zoom" src={hisenseLogo} alt="..." />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/*todo: hero description*/}
      <section
        id="showcase"
        className="bg-gray-100 py-8 lg:py-16 place-self-center rounded-t-2xl"
      >
        <div className="tw-container grid lg:grid-cols-2 place-items-center gap-x-32 gap-y-8 md:gap-y-16 lg:gap-y-4">
          <article style={{ textAlign: "-webkit-center" }} className="mb-2">
            <img
              alt={"..."}
              className="w-1/2 md:w-full place-self-center aspect-video"
              src={efacility}
            />
            <p
              className={`mt-8 max-w-lg leading-loose text-lg ${
                i18n.language === "ar" ? "lg:text-right" : "lg:text-left"
              }`}
            >
              {t("home.description")}
            </p>

            <Link
              to="/products"
              className={`gap-4 flex h-14 align-middle btn text-sm sm:text-xl px-6 py-3 bg-primary-color rounded-lg text-white hover:bg-yellow-500 transition w-max text-center mt-8 ${
                i18n.language === "ar" ? "lg:float-right" : "lg:float-left"
              }`}
            >
              <Cart color="#fff" />
              <div className="align-middle my-auto">
                {t("home.btnboutique")}
              </div>
            </Link>
          </article>

          <img
            alt={"..."}
            className="object-contain rounded-md"
            src={entreprise}
          />
        </div>
      </section>

      <section className="place-self-center rounded-b-2xl overflow-hidden">
        <BreadcrumbsHome>
          <Link
            to="/contact"
            className={`text-sm md:text-lg xl:text-2xl ${
              i18n.language === "fr" ? "" : "font-cairo"
            }`}
          >
            {/*todo: Contactez-nous*/}
            <button
              onMouseEnter={() => setButtonHovered3(true)}
              onMouseLeave={() => setButtonHovered3(false)}
              className="flex items-center justify-center text-secondary-color px-6 py-2 transition ease-in duration-200 uppercase rounded-2xl hover:bg-secondary-color hover:text-primary-color border-2 border-secondary-color focus:outline-none"
            >
              <img
                alt={"..."}
                className="w-8 mr-4"
                src={buttonHovered3 ? support_bleu : support_yellow}
              />
              {t("home.contactUs")}
            </button>
          </Link>
          <Link
            to="/dossier"
            className={`text-sm md:text-lg xl:text-2xl ${
              i18n.language === "fr" ? "" : "font-cairo"
            }`}
          >
            {/*todo: Dossier à fournir*/}
            <button
              className="flex items-center justify-center  text-secondary-color px-6 py-2 transition ease-in duration-200 uppercase rounded-2xl hover:bg-secondary-color hover:text-primary-color border-2 border-secondary-color focus:outline-none"
              onMouseEnter={() => setButtonHovered(true)}
              onMouseLeave={() => setButtonHovered(false)}
            >
              <img
                alt={"..."}
                className="w-8 mr-4"
                src={buttonHovered ? file_blue : file_yellow}
              />
              {t("home.fileProvided")}
            </button>
          </Link>
          <Link
            to="/eligibility"
            className={`text-sm md:text-lg xl:text-2xl ${
              i18n.language === "fr" ? "" : "font-cairo"
            }`}
          >
            {/*todo: Critères d’Eligibilité*/}
            <button
              onMouseEnter={() => setButtonHovered2(true)}
              onMouseLeave={() => setButtonHovered2(false)}
              className="flex items-center justify-center  text-secondary-color px-2 py-2 transition ease-in duration-200 uppercase rounded-2xl hover:bg-secondary-color hover:text-primary-color border-2 border-secondary-color focus:outline-none"
            >
              <img
                alt={"..."}
                className="w-8 mr-4"
                src={buttonHovered2 ? criteria_blue : criteria_yellow}
              />
              {t("home.Criteria")}
            </button>
          </Link>
        </BreadcrumbsHome>
      </section>

      <section className="my-8">
        <img className="rounded-2xl" src={sectionBEA} alt="..." />
      </section>

      <section id="featured-products" className="place-self-center">
        <div className="tw-container w-full py-16">
          <div className="my-8">
            <h2 className="text-center text-3xl lg:text-4xl">
              {t("populaire.title")}
            </h2>
            <div className="mt-3 w-24 h-1 bg-primary-color mx-auto" />
          </div>
          <div className="relative">
            <button className="hidden lg:block custom-prev absolute -left-14 top-1/2 transform -translate-y-1/2 p-2 bg-primary-color transition hover:bg-secondary-color text-white rounded-full">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>
            <button className="hidden lg:block custom-next absolute -right-14 top-1/2 transform -translate-y-1/2 p-2 bg-primary-color transition hover:bg-secondary-color text-white rounded-full">
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
            {isLoading ? (
              <p className="text-center h-full w-full">Loading</p>
            ) : (
              <Swiper
                modules={[Autoplay, Pagination, Navigation]}
                spaceBetween={30}
                slidesPerView={1}
                centeredSlides={true}
                loop={true}
                autoplay={{
                  delay: 4000,
                }}
                pagination={{
                  // enabled: true,
                  clickable: true,
                  dynamicBullets: true,
                  // dynamicMainBullets: 3,
                  el: ".swiper-custom-pagination",
                }}
                navigation={{
                  nextEl: ".custom-next",
                  prevEl: ".custom-prev",
                }}
                className="mt-4"
              >
                {products.map((product, index) => {
                  if (
                    index % (xsDown ? 1 : smDown ? 4 : mdDown ? 6 : 8) ===
                    0
                  ) {
                    const productSet = products.slice(
                      index,
                      index + (xsDown ? 1 : smDown ? 2 : mdDown ? 3 : 4)
                    );
                    const productSet2 = products.slice(
                      index + (xsDown ? 1 : smDown ? 2 : mdDown ? 3 : 4),
                      index + (xsDown ? 2 : smDown ? 4 : mdDown ? 6 : 8)
                    );
                    return (
                      <SwiperSlide key={index}>
                        <div className="grid gap-2 grid-rows-1 sm:grid-rows-2 w-full">
                          <div
                            className={`grid gap-2 ${
                              xsDown
                                ? "grid-cols-1"
                                : smDown
                                ? "grid-cols-2"
                                : mdDown
                                ? "grid-cols-3"
                                : "grid-cols-4 "
                            }`}
                          >
                            {productSet.map((product, key) => (
                              <ProductCard
                                key={key}
                                {...product}
                                grid={true}
                                local={i18n.language}
                              />
                            ))}
                          </div>
                          {!xsDown ? (
                            <div
                              className={`grid gap-2 ${
                                xsDown
                                  ? "grid-cols-1"
                                  : smDown
                                  ? "grid-cols-2"
                                  : mdDown
                                  ? "grid-cols-3"
                                  : "grid-cols-4 "
                              }`}
                            >
                              {productSet2.map((product, key) => (
                                <ProductCard
                                  key={key}
                                  {...product}
                                  grid={true}
                                  local={i18n.language}
                                />
                              ))}
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </SwiperSlide>
                    );
                  }
                  return null;
                })}
                <div className="swiper-custom-pagination" />
              </Swiper>
            )}

            <Link to="/products">
              <button className="btn-sm md:btn mx-auto bg-primary-color hover:bg-yellow-500 transition rounded-xl p-4 text-white font-semibold">
                {t("populaire.plus")}
              </button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
